import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-hda',
    templateUrl: './default/hda/hda.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class HdaComponent extends UnitsDistributionBase {
  // Used for both FOOTBALL_HDA and FOOTBALL_MATCH_RESULT
  // Also used for ICE_HOCKEY_HDA
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}